export function returnToHome({ router, location } = {}) {
  if (location && typeof location.assign === "function") {
    location.assign("/")
    return
  }

  if (router && typeof router.push === "function") {
    router.push("/")
  }
}

export function startOnboardingAutoRedirect({
  durationMs,
  performance,
  requestAnimationFrame,
  cancelAnimationFrame,
  onTick,
  onRedirect,
}) {
  onTick?.(durationMs)

  let frameId = 0
  const startedAt = performance.now()

  const tick = () => {
    const elapsed = performance.now() - startedAt
    const remaining = Math.max(0, durationMs - elapsed)
    onTick?.(remaining)

    if (remaining <= 0) {
      onRedirect?.()
      return
    }

    frameId = requestAnimationFrame(tick)
  }

  frameId = requestAnimationFrame(tick)

  return () => {
    if (typeof cancelAnimationFrame === "function" && frameId) {
      cancelAnimationFrame(frameId)
    }
  }
}
